
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api"; // Your shared axios instance
import { showLoader, hideLoader } from "./loaderSlice";

export const getServiceList = createAsyncThunk(
  "getServiceList",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(`/getall/clinic/serviceorproducts`);

      if (res.status === 200) {
        const services = res.data.data.filter((item) => item.type === "service");
        thunkAPI.dispatch(hideLoader());
        return services;
      }
      thunkAPI.dispatch(hideLoader());
      return [];
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to fetch services");
    }
  }
);

export const createService = createAsyncThunk(
  "createService",
  async ({ category, subCategory }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/create/clinic/serviceorproduct`,
        {
          type: "service",
          category,
          subCategory
        }
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to create service");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const updateService = createAsyncThunk(
  "updateService",
  async ({ id, category, subCategory }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/serviceorproduct/${id}`,
        {
          type: "service",
          category,
          subCategory
        }
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return res?.data?.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to update service");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

export const deleteService = createAsyncThunk(
  "deleteService",
  async ({ id }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/clinic/serviceorproduct/${id}`
      );

      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        return id; // Return ID to remove from list
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to delete service");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  }
);

const serviceSlice = createSlice({
  name: "service",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getServiceList.fulfilled, (state, action) => {
        state.list = action.payload ?? [];
        state.loading = false;
        state.error = null;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.list.push(action.payload);
        state.loading = false;
        state.error = null;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        const updated = action.payload;
        const index = state.list.findIndex((s) => s.id === updated.id);
        if (index !== -1) {
          state.list[index] = updated;
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(deleteService.fulfilled, (state, action) => {
        const id = action.payload;
        state.list = state.list.filter((s) => s.id !== id);
        state.loading = false;
        state.error = null;
      })
      .addCase(getServiceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(createService.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateService.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteService.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Error fetching services.";
      });
  },
});

export default serviceSlice.reducer;